export const blockTypes = [
  'heading',
  'paragraph',
  'bulletListItem',
  'numberedListItem',
  'table',
  'image',
] as const;
